import { useDialog } from "@shared/features/dialog/useDialog";
import { useGetUserData } from "@platform/hooks/useGetUserData";
import { FriendInvitationDeletionDialog } from "../../../friendInvitation/components/FriendInvitationDeletionDialog/FriendInvitationDeletionDialog";
import { useProgram } from "../../hooks/useProgram";

export function ProgramFriendInviteDeletion() {
  const { activeDialog, closeDialog } = useDialog();

  const isOpen = activeDialog === "invitationDelete";

  const { invitation, program } = useProgram();

  const { refetch: refetchUserData } = useGetUserData();

  if (!invitation || !program) return null;

  const handleDone = async () => {
    // refetch user data
    await refetchUserData();

    // close the dialog
    closeDialog("invitationDelete");
  };

  return (
    <FriendInvitationDeletionDialog
      onDone={handleDone}
      onClose={handleDone}
      isOpen={isOpen}
      invitation={invitation}
      programId={parseInt(program.id, 10)}
    />
  );
}

export default ProgramFriendInviteDeletion;
